import { render, staticRenderFns } from "./m-block-shift-close.vue?vue&type=template&id=c648e014&scoped=true&lang=pug&"
import script from "./m-block-shift-close.vue?vue&type=script&lang=js&"
export * from "./m-block-shift-close.vue?vue&type=script&lang=js&"
import style0 from "./m-block-shift-close.vue?vue&type=style&index=0&id=c648e014&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c648e014",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRadio,VRadioGroup,VRow})
